export const getPermission = (userPermissons, permission) => {
  const data = userPermissons?.filter((item) => item === permission);

  if (data?.length > 0) return data;

  return null;
};
